import { render, staticRenderFns } from "./StoreRegister.vue?vue&type=template&id=b53a553a&scoped=true&"
import script from "./StoreRegister.vue?vue&type=script&lang=js&"
export * from "./StoreRegister.vue?vue&type=script&lang=js&"
import style0 from "./StoreRegister.vue?vue&type=style&index=0&id=b53a553a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b53a553a",
  null
  
)

export default component.exports